<template>
  <div>

    <b-alert variant="danger"
             class="col-md-12"
             v-if="getOrder.id_recapitulatif!=0"
             show>
      <p class="pull-left">
        Ce bon de commande a déjà été converti en
        <router-link
          :to="{ name: 'Recap', params: { recap_id: getOrder.id_recapitulatif }}">
          récapitulatif n°{{ getOrder.id_recapitulatif |idFormat }}
        </router-link>
        et ne devrait pas être modifié!
      </p>
      <button type="button"
              class="btn btn-md btn-default btn-flat pull-right "
              @click="goToRecap()"
      >
        Afficher le récapitulatif
      </button>
    </b-alert>

    <b-alert variant="success"
             class="col-md-12"
             v-if="getOrderOriginal.order_payed && getOrder.id_recapitulatif==0"
             show>
      <p class="pull-left">
        Vous pouvez convertir ce bon de commande en récapitulatif
      </p>
      <button type="button"
              class="btn btn-md btn-default btn-flat pull-right "
              @click="convertToRecap()"
      >
        Convertir en récapitulatif
      </button>
    </b-alert>

    <b-alert variant="warning"
             class="col-md-12"
             v-if="!getOrderOriginal.order_payed && getOrder.id_recapitulatif==0"
             show>
      <p class="pull-left">
        Attention, la commande n'est pas encore payée. <br>
        Vous ne devriez pas convertir ce bon de commande en récapitulatif
      </p>
      <button type="button"
              class="btn btn-md btn-default btn-flat  pull-right"

              @click="convertToRecap()"
      >
        Convertir en récapitulatif
      </button>
    </b-alert>

    <form role="form">
      <div class="overlay" v-if="isClotureValide()">
        <div class="row">
          <div class="col-md-12"
               style="padding:5%;text-align: center; font-size: 16px; border:1px solid black;background-color:#FFF;width: 90%;margin: 5%;">
            <p>Ce bon de commande est au statut <strong> "{{getOrder.statut.statut}}"</strong>. <br>Toute
              modification peut entraîner une modification comptable et devrait être mentionné au club.
              <br><br>
              <template v-if="getOrder.id_recapitulatif!=0">
                <strong class="text-red">
                  Ce bon de commande a déjà été converti en
                  <router-link
                    :to="{ name: 'Recap', params: { recap_id: getOrder.id_recapitulatif }}">
                    récapitulatif n°{{ getOrder.id_recapitulatif |idFormat }}
                  </router-link>
                  et ne devrait pas être modifié!
                </strong>
                <br><br>Souhaitez-vous modifier ce bon commande ?
              </template>
            </p>
            <button type="button"
                    class="btn btn-md btn-default btn-flat margin align-center"
                    style="margin-top: 0;margin-bottom: 0;"
                    @click="acceptToModifyOrder=true"
            >
              Modifier ce bon de commande
            </button>
            <button type="button"
                    class="btn btn-md btn-primary btn-flat margin align-center"
                    style="margin-top: 0;margin-bottom: 0;"
                    v-if="getOrder.id_recapitulatif!=0"
                    @click="goToRecap()"
            >
              Voir le récapitulatif lié
            </button>
          </div>
        </div>

      </div>
      <div class="row">
        <div class="col-md-6">

          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Données du bon de commande</h3>
              <button type="button"
                      class="btn btn-xs btn-danger btn-flat margin pull-right"
                      style="margin-top: 0;margin-bottom: 0;"
                      @click="supprimerOrder()"
              >
                Supprimer le bon de commande
              </button>
            </div>

            <div class="box-body">

              <div class="form-group">
                <div class="col-md-6">
                  <label for="statut">Créé par:</label>
                  <router-link :to="{ name: 'Member', params: { member_id: getOrder.my_a_b_f_t_user.id_membre }}">
                    <h4><strong>{{ getOrder.my_a_b_f_t_user.member.fullName }}</strong></h4>
                  </router-link>
                </div>
                <div class="col-md-6">
                  <label for="statut">Pour le club:</label>
                  <router-link :to="{ name: 'Club', params: { club_id: getOrder.club.id }}">
                    <h4><strong>{{ getOrder.club.nameFormat }}</strong></h4>
                  </router-link>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group"
                     :class="{'has-error': errors.has('order[date]') }">
                  <label>Date du bon de commande</label>
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar"></i>
                    </div>
                    <masked-input type="text"
                                  v-model="getOrder.date"
                                  v-validate="'required|date_format:DD/MM/YYYY'"
                                  :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                                  :guide="true"
                                  :keepCharPositions="true"
                                  :showMask="true"
                                  name="order[date]"
                                  class="form-control pull-right datepicker"
                                  id="datepicker31">
                    </masked-input>
                  </div>
                  <span v-show="errors.has('order[date]')"
                        class="help-block">Date incorrecte</span>
                </div>

                <div class="form-group">
                  <label for="statut">Statut actuel</label>
                  <select id="statut" class="form-control" name="order[statut]"
                          v-model="getOrder.statut.id">
                    <option
                      v-for="statut in getStatusOrder"
                      :value="statut.id"
                    > {{ statut.statut }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="statut">Moyen de payement:</label>
                  <select id="mode_payement" class="form-control" name="order[statut]"
                          v-model="getOrder.mode_payement.id">
                    <option
                      v-for="mode in getModesPayement"
                      :value="mode.id"
                    > {{ mode.mode }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="statut">Moyen de livraison:</label>
                  <select id="mode_livraison" class="form-control" name="order[statut]"
                          v-model="getOrder.mode_livraison.id">
                    <option
                      v-for="mode in getModesLivraison"
                      :value="mode.id"
                    > {{ mode.mode }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group"
                     :class="{'has-error': errors.has('order[adresse_livraison]') }">
                  <label for="nom">Adresse de livraison</label>
                  <textarea type="text" class="form-control" id="nom" name="order[adresse_livraison]"
                            rows="5"
                            v-validate="'max:25000'"
                            placeholder="Commentaire(s) éventuel(s)"
                            v-model="getOrder.adresse_livraison">{{getOrder.adresse_livraison}}</textarea>
                  <span v-show="errors.has('order[adresse_livraison]')" class="help-block">L'adresse doit comporter moins de 25000 caractères</span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group"
                     :class="{'has-error': errors.has('order[adresse_facturation]') }">
                  <label for="nom">Adresse de facturation</label>
                  <textarea type="text" class="form-control" id="nom" name="order[adresse_facturation]"
                            rows="5"
                            v-validate="'max:25000'"
                            placeholder="Commentaire(s) éventuel(s)"
                            v-model="getOrder.adresse_facturation">{{getOrder.adresse_facturation}}</textarea>
                  <span v-show="errors.has('order[adresse_facturation]')" class="help-block">L'adresse doit comporter moins de 25000 caractères</span>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="statut">Communication structurée
                    (n°{{ [getOrder.numero_officiel.toString().substring(0, 4), getOrder.numero_officiel.toString().substring(4)].join('-') }}):
                  </label>
                  <input class="form-control" type="text" disabled v-model="getOrder.communication_structuree">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="statut">Payement reçu ?</label>
                  <div class="checkbox">
                    <label for="show_in_ranking">
                      <input id="show_in_ranking" type="checkbox" name="getOrder[order_payed]"
                             v-model="order_payed">Bon de commande payé <br/>
                      <a target="_blank" :href="'https://dashboard.stripe.com/payments/'+this.getOrder.guid_stripe"
                         v-if="this.getOrder.guid_stripe">Voir le détail sur Stripe.com - {{this.getOrder.guid_stripe}}</a>
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group"
                     :class="{'has-error': errors.has('order[comment]') }">
                  <label for="nom">Commentaire</label>
                  <textarea type="text" class="form-control" id="nom" name="order[comment]"
                            v-validate="'max:25000'"
                            placeholder="Commentaire(s) éventuel(s)"
                            v-model="getOrder.comment">{{getOrder.comment}}</textarea>
                  <span v-show="errors.has('order[comment]')" class="help-block">Le commentaire doit comporter moins de 25000 caractères</span>
                </div>
              </div>
            </div>
          </div>

          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Mails à envoyer</h3>
            </div>
            <div class="box-body">
              <div class="overlay"
                   v-if="this.btnsSendMailsBusy"
              >
                <i class="fa fa-refresh fa-spin"></i>
              </div>

              <div class="col-md-12 margin ">
                <div class="form-group" :class="{'has-error': errors.has('mailToSend') }">
                  <label for="prenom">Renvoyer le mail pour demande de payement à</label>
                  <input type="text" class="form-control" id="prenom" name="mailToSend"
                         v-validate="'email'"
                         placeholder="Email du membre"
                         v-model="mailToSend">
                  <span v-show="errors.has('mailToSend')" class="help-block">L'adresse e-mail doit être correcte</span>
                </div>

                <div class="input-group">
                  <span class="input-group-btn">
                    <a type="button"
                       :disabled="!mailToSend"
                       @click="sendMail('must_pay')"
                       class="btn btn-primary btn-flat">
                      Renvoyer une demande de payement
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="col-md-6">

          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Produits commandés</h3>
            </div>
            <div class="box-body">
              <div class="overlay" v-if="isTableProduitsLoading()">
                <i class="fa fa-refresh fa-spin"></i>
              </div>

              <div v-if="!isTableProduitsLoading()">
                <b-table responsive bordered striped hover
                         :items="getOrder.my_a_b_f_t_products"
                         :fields="columnsProductsInOrder"
                         :per-page="perPage"
                         :current-page="currentPage"
                         :empty-text="'Aucun résultat'"
                         :empty-filtered-text="'Aucun résultat'"
                         foot-clone
                         show-empty
                >
                  <template slot="actions" slot-scope="row">
                    <a href="#" @click.prevent="removeProduct(row.item.id)"
                       class="btn btn-default padding2">
                      <i class="glyphicon glyphicon-remove"></i>
                    </a>
                  </template>
                  <template slot="id" slot-scope="data">
                    {{ data.value | idFormat }}
                  </template>
                  <template slot="link" slot-scope="row">
                    <router-link
                      :to="getRouteByType(row.item.orderable_type,row.item.orderable_id)">
                      {{ row.item.orderable_name }}
                    </router-link>
                  </template>
                  <template slot="product_type" slot-scope="row">
                    {{ row.item.my_a_b_f_t_product.description }}
                    <span v-if="row.item.my_a_b_f_t_product.product=='licence_club'">{{formatDate(row.item.date_debut,"YYYY-MM-DD","YYYY")}}</span>
                  </template>
                  <template slot="cost" slot-scope="row">
                    {{ row.item.cost }}€
                  </template>
                  <!--<template slot="FOOT_id" slot-scope="foo"></template>-->
                  <!--<template slot="FOOT_nom" slot-scope="foo"></template>-->
                  <!--<template slot="FOOT_type_rel" slot-scope="foo"></template>-->
                  <template slot="FOOT_cost" slot-scope="foo">
                    <strong>{{ getOrder.total }}€</strong>
                  </template>
                  <template slot="FOOT_actions" slot-scope="foo"></template>
                </b-table>
                <b-pagination size="md"
                              :total-rows="getOrder.my_a_b_f_t_products.length"
                              v-model="currentPage"
                              :per-page="perPage">
                </b-pagination>
              </div>
            </div>
          </div>

          <div class="box box-primary" v-if="getOrder.id">
            <div class="overlay" v-if="isTableProduitsLoading()">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="box-header with-border">
              <h3 class="box-title">Ajouter un produit</h3>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="statut">Type de produit</label>
                    <select id="typeProduct" class="form-control" name="newProduct[typeProduct]"
                            v-model="newProduct.typeProduct">
                      <option
                        v-for="type in getTypeProducts"
                        :value="type"
                      > {{ type.description }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row" v-if="showOrderableSelect">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="memberSearch">Recherche de membre</label>
                    <v-select v-model="newProduct.idOrderable"
                              label="fullName"
                              id="memberSearch"
                              :filterable="false"
                              :debounce="250"
                              :on-search="SearchMembersResponse"
                              :options="ArrayMembersSearch">

                      <div slot="selected-option" slot-scope="props">
                        <router-link
                          :to="{ name: 'Member', params: { member_id: props.selectedOption.id }}">
                          {{ props.selectedOption.fullName }}
                        </router-link>
                      </div>
                      <div slot="option" slot-scope="props">
                        <span :class="props.item.licencie? 'text-green' : 'text-red'">{{ props.item.fullName }}</span>
                      </div>
                    </v-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group" v-show="newProduct.typeProduct!=null && newProduct.idOrderable!=null"
                       :class="{ 'has-error': showErrorCostProduct }">
                    <label for="MontantDe">&nbsp;</label>
                    <div class="input-group">
                      <span class="input-group-addon">€</span>
                      <input type="text" name="montant" class="form-control" id="MontantDe"
                             v-model="newProduct.cost" placeholder="">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <button @click.prevent="addProduct()"
                          :disabled="newProduct.typeProduct==null || newProduct.idOrderable==null"
                          class="btn btn-primary">Ajouter
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="nav-tabs-custom">
            <ul class="nav nav-tabs">
              <li class="active">
                <a href="#tab_0" data-toggle="tab" aria-expanded="true">Logs</a>
              </li>
            </ul>

            <div class="tab-content">
              <div class="tab-pane active" id="tab_0">
                <b-table
                  id="tableLogsOrder"
                  responsive bordered striped hover
                  :items="getOrder.log"
                  :fields="logsOptions.columnsLog"
                  :current-page="logsOptions.pagination_meta.current_page"
                  :per-page="logsOptions.pagination_meta.per_page"
                  :empty-text="'Aucun résultat'"
                  :empty-filtered-text="'Aucun résultat'"
                  foot-clone
                  show-empty
                >
                  <template slot="created_at" slot-scope="row">
                    {{ row.item.date }}
                  </template>
                  <span slot="fullDescription" slot-scope="data" v-html="data.value"> </span>
                </b-table>
                <b-pagination size="md"
                              :total-rows="getOrder.log.length"
                              v-model="logsOptions.pagination_meta.current_page"
                              :per-page="logsOptions.pagination_meta.per_page">
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="box ">
            <div class="overlay"
                 v-if="this.disabledBtn"
            >
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="box-body">
            </div>
            <div class="box-footer">

              <button type="button"
                      class="btn btn-lg btn-primary btn-flat margin pull-right"
                      :disabled="errors.count()!=0 || this.disabledBtn || this.loadingInputs.length>0"
                      @click="updateOrder(true)"
              >
                Enregistrer les modifications et envoyer un mail automatique au club
              </button>
              <button type="button"
                      class="btn btn-lg btn-secondary btn-flat margin pull-right"
                      :disabled="errors.count()!=0 || this.disabledBtn || this.loadingInputs.length>0"
                      @click="updateOrder()"
              >
                Enregistrer les modifications
              </button>


            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {ErrorBag} from 'vee-validate';
import vSelect from '../../Communs/vSelect/index'

var $ = require('jquery');
var variables = require('../../../assets/js/variables')
var _ = require('underscore')
var moment = require('moment')
var FileSaver = require('file-saver');

export default {
  props: {
    loadingTableProduits: {
      required: true,
      'default': false
    },
  },
  data() {
    return {
      acceptToModifyOrder: false,
      loadingInputs: [],
      ArrayMembersSearch: [],
      disabledBtn: false,
      btnsSendMailsBusy: false,
      resize: false,
      activeTab: "default",
      activeDojang: null,
      dataTableLogClub: null,
      dataTableFilesClub: null,
      redraw: "",
      loadingSecretariatBox: false,
      loadingWhitoutOrder: false,
      loadingCurrentYear: false,
      showOrderableSelect: false,
      showErrorCostProduct: false,
      previousRequest: false,
      mailToSend: null,
      costProductSelected: 0,
      licencesWithoutOrder: [],
      licencesCurrentYear: [],
      currentPage: 1,
      perPage: 20,
      currentPage2: 1,
      perPage2: 20,
      currentPage3: 1,
      perPage3: 20,
      sortByMembresInOrder: 'id',
      sortDescMembresInOrder: false,
      newProduct: {
        typeProduct: null,
        idOrderable: null,
        cost: 0,
      },
      columnsProductsInOrder: [
        {
          label: 'ID',
          key: 'id',
          sortable: false,
        },
        {
          label: 'Type',
          key: 'product_type',
          sortable: false,
        },
        {
          label: 'Lié à',
          key: 'link',
          sortable: false,
        },
        {
          label: 'Coût',
          key: 'cost',
          sortable: true,
        },
        {
          label: 'Actions',
          key: 'actions',
        },
      ],
      columnsLicencesWithoutOrder: [
        {
          label: 'Num. Lic.',
          key: 'id',
          sortable: true,
        },
        {
          label: 'Club',
          key: 'club',
          sortable: true,
        },
        {
          label: 'Nom',
          key: 'nom',
          sortable: true,
        },
        {
          label: 'Type',
          key: 'type_rel',
          sortable: true,
        },
        {
          label: 'Actions',
          key: 'actions',
        },
      ],
      logsOptions: {
        columnsLog: [
          {
            label: 'Date',
            key: 'created_at',
            sortable: true,
          },
          {
            label: 'Action',
            key: 'fullDescription',
            sortable: false,
          },
          {
            label: 'Responsable',
            key: 'user',
            sortable: true,
          },
        ],
        pagination_meta: {
          current_page: 1,
          from: 1,
          last_page: 1,
          path: "",
          per_page: 40,
          to: 1,
          total: 1
        },
      },
      order_payed: false
    }
  },
  computed: {
    ...mapGetters({
      getRoute: 'getRoute',
      getStatusOrder: 'getStatusOrder',
      getModesPayement: 'getModesPayement',
      getModesLivraison: 'getModesLivraison',
      getTypeProducts: 'getTypeProducts',
      getTextesOrder: 'getTextesOrder',
      getOrderOriginal: 'getOrderOriginal',
      getOrder: 'getOrder'
    }),
  },
  mounted: function () {
    var these = this
    this.order_payed = this.getOrder.order_payed
    this.mailToSend = this.getOrder.my_a_b_f_t_user.member.mail
  },
  created() {
  },
  beforeRouteEnter(to, from, next) {
    next()
  },
  watch: {
    'newProduct.typeProduct': function (value) {
      if (!this.newProduct || value == null)
        return this.showOrderableSelect = false
      this.newProduct.cost = value.cost
      if (value.product == 'renew' || value.product == 'duplicata')
        this.showOrderableSelect = true
    },
    getOrder: function (value) {
      this.order_payed = this.getOrder.order_payed
    }
  },
  components: {
    vSelect,
  },
  methods: {
    ...mapActions({}),
    convertToRecapApi: function () {
      return this.$http.post(this.getRoute('Secretariat.ordermyabft.convertoToRecap'), {id_order: this.getOrder.id})
        .then(function (response) {
          // self.$noty.success("Le bon de commande a bien été modifié")
          // this.$emit('onNeedRefreshOrder', true)
          this.$router.push({name: 'Recap', params: {recap_id: response.body.id}})
          this.disabledBtn = false
        }, (response) => {
          self.$noty.error("Erreur dans la convertion")
          this.disabledBtn = false
        });
    },

    convertToRecap: function () {
      this.disabledBtn = true;
      let self = this;

      if (!this.getOrderOriginal.order_payed && this.getOrder.id_recapitulatif == 0) {
        this.$dialog.confirm('' +
          'Confirmez-vous la création d\'un récapitulatif ?<br/><br/> ' +
          'Attention, la commande n\'est pas encore payée. <br><br>' +
          'Vous <u>ne devriez pas</u> convertir ce bon de commande en récapitulatif avant d\'avoir reçu le payement',
          {
            html: true, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
            loader: true, // set to true if you want the dailog to show a loader after click on "proceed"
            reverse: false, // switch the button positions (left to right, and vise versa)
            okText: 'Créer un récapitulatif',
            cancelText: 'Annuler',
            animation: 'zoom', // Available: "zoom", "bounce", "fade"
            type: 'basic', // coming soon: 'soft', 'hard'
          })
          .then(function (dialog) {
            setTimeout(() => {
              self.convertToRecapApi()
              dialog.close();
            }, 1000);
          })
          .catch(function () {
            dialog.close();
          });

      } else {
        self.convertToRecapApi()
      }


    },
    addProduct: function () {
      this.isTableProduitsLoading(true);
      this.isBusy = true
      let self = this
      // debugger;
      this.$http.post(self.getRoute('Secretariat.ordermyabft.addProduct'), {
        id_order: this.getOrder.id,
        id_product: this.newProduct.typeProduct.id,
        orderable_id: this.newProduct.idOrderable.id,
        orderable_type: this.newProduct.typeProduct.product == 'renew' || this.newProduct.typeProduct.product == 'duplicata' ? 'member' : '',
        cost: this.newProduct.cost,
      })
        .then((response) => {
          self.$noty.success("Le produit a bien été ajouté à ce bon de commande")
          self.$emit('onNeedRefreshOrder')
          self.newProduct = {
            typeProduct: null,
            idOrderable: null,
            cost: 0,
          }
          self.isTableProduitsLoading(false);
        }, (response) => {
          self.isTableProduitsLoading(false);
          self.$noty.error("Erreur dans l'ajout du produit")
        });
    },
    getRouteByType: function (type, orderable_id) {
      switch (type) {
        case "App\\Models\\Communs\\Member":
          return {name: 'Member', params: {member_id: orderable_id}}
          break
        case "App\\Models\\Communs\\Club":
          return {name: 'Club', params: {club_id: orderable_id}}
          break

        default:
          return null
      }
    },
    SearchMembersResponse: function (search, loading) {
      if (search.length <= 2)
        return;
      loading(true)
      this.$http.post(this.getRoute("memberSearch"), {q: search},
        {
          before(request) {
            // abort previous request, if exists
            if (this.previousRequest) {
              this.previousRequest.abort();
            }
            // set previous request on Vue instance
            this.previousRequest = request;
            this.loading = true
          }
        }).then(resp => {
        loading(false)
        this.ArrayMembersSearch = resp.data
        this.ArrayMembersSearch = _.where(this.ArrayMembersSearch, {licencie: true}).concat(_.where(this.ArrayMembersSearch, {licencie: false}))
      })
    },
    sortCompareAdvanced: function (a, b, key) {
      // debugger
      return this.$sortCompareAdvanced(a, b, key)
    },
    isClotureValide: function () {
      // debugger;
      return (this.getOrder.statut.meta == 'sent' ||this.getOrder.statut.meta == 'sending' || this.getOrder.statut.meta == 'wait_pay' || this.getOrder.statut.meta == 'prepare') && !this.acceptToModifyOrder;
      // return this.getOrder.statut.meta=='done' && !this.acceptToModifyOrder;
    },
    currentYear: function () {
      return moment().year();
    },

    isTableProduitsLoading: function (force = false) {
      if (force)
        return true
      return this.loadingTableProduits;
    },
    printOrder: function () {
      let these = this;
      if (!this.getOrder.id || !this.getOrder.licences || this.getOrder.licences.length <= 0)
        return;
      this.loadingSecretariatBox = true

      this.$http.post
      (
        this.getRoute('generateFacture'),
        JSON.stringify({"id_order": these.getOrder.id}),
        {responseType: 'blob'}
      ).then(function (response) {
        this.loadingSecretariatBox = false
        var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
        FileSaver.saveAs(blob, "Orderitulatif_" + these.getOrder.id + ".pdf");
        return response.blob();
      }, (response) => {
        these.$noty.error("Erreur dans la génération du récap")
        this.loadingSecretariatBox = false
      });

    },
    goToRecap: function () {
      this.$router.push({name: 'Recap', params: {recap_id: this.getOrder.id_recapitulatif}})
    },
    console: function (event) {
      console.log(event);
    },
    copyToClipboard: function (message) {
      let self = this;
      this.$copyText(message).then(function (e) {
        self.$noty.success("E-mail copié dans le presse-papier")

      }, function (e) {
        self.$noty.error("Erreur dans l'accès au presse-papier")
      })
    },
    sendMail: function (type) {
      if (!this.mailToSend)
        return
      let self = this;
      this.btnsSendMailsBusy = true
      this.$http.post(this.getRoute('Secretariat.ordermyabft.sendMail'),
        {id_order: this.getOrder.id, type_mail: type, mail: this.mailToSend}).then(function (response) {
        self.$noty.success("Le mail a bien été envoyé.")
        this.btnsSendMailsBusy = false
        // console.log(response.body)
        if (type == 'order_non_paye') {
          self.getOrder.statut = response.body.statut
        }
      }, (response) => {
        this.btnsSendMailsBusy = false
        self.$noty.error("Erreur dans l'envoi du mail.")
      });
    },
    constructMail: function (key) {
      if (!this.getTextesOrder || !this.getTextesOrder[key].body)
        return '';
      return "mailto:" + (this.getTextesOrder[key].to ? this.getTextesOrder[key].to + '?' : "?") +
        "subject=" + this.getTextesOrder[key].subject +
        (this.getTextesOrder[key].cc ? "&cc=" + this.getTextesOrder[key].cc : "") +
        (this.getTextesOrder[key].cci ? "&bcc=" + this.getTextesOrder[key].cci : "")
    },
    constructForm: function (prevenirClub) {
      return JSON.stringify({
        "id_club": this.getOrder.id_club,
        "date": moment(this.getOrder.date, 'DD/MM/YYYY').format("YYYY-MM-DD"),
        "adresse_livraison": this.getOrder.adresse_livraison,
        "adresse_facturation": this.getOrder.adresse_facturation,
        "id_statut": this.getOrder.statut.id,
        "id_mode_payement": this.getOrder.mode_payement.id,
        "id_mode_livraison": this.getOrder.mode_livraison.id,
        "order_payed": this.order_payed,
        "comment": this.getOrder.comment == null ? "" : this.getOrder.comment,
        "prevenirClub": prevenirClub
      })
    },
    formatDate: function (value, fmtIn = 'YYYY-MM-DD hh:mm:ss', fmtOut = 'DD/MM/YYYY HH:mm') {
      if (value == null) return ''
      return moment(value, fmtIn).format(fmtOut)
    },
    supprimerOrder: function () {
      if (this.getOrder.id_recapitulatif != 0)
        return this.$noty.error("Ce bon de commande est lié à un récapitulatif. Veuillez supprimer ce récapitulatif avant de supprimer le bon de commande.")
      let these = this
      let self = this
      this.$dialog.confirm('' +
        'Confirmez-vous la suppression de ce bon de commande ?<br/><br/> ' +
        'ATTENTION: Si un récapitulatif a été créé depuis ce bon de commande, celui-ci ne sera pas supprimé. Vous devrez le supprimer manuellement.',
        {
          html: true, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
          loader: true, // set to true if you want the dailog to show a loader after click on "proceed"
          reverse: false, // switch the button positions (left to right, and vise versa)
          okText: 'Supprimer le bon de commande',
          cancelText: 'Annuler',
          animation: 'zoom', // Available: "zoom", "bounce", "fade"
          type: 'basic', // coming soon: 'soft', 'hard'
        })
        .then(function (dialog) {
          setTimeout(() => {
            self.$http.post(self.getRoute('Secretariat.ordermyabft.delete'), {id_order: self.getOrder.id})
              .then(function (response) {
                self.$noty.success("Bon de commande supprimé")
                self.$router.push('/');
                dialog.close();
              }, (response) => {
                self.$noty.error("Erreur dans la suppression")
                dialog.close();
              });
          }, 1000);
        })
        .catch(function () {
        });
    },
    updateOrder: function (prevenirClub = false) {
      this.disabledBtn = true;
      let self = this;
      this.$http.put(this.getRoute('Secretariat.OrderMyABFT.update') + this.getOrder.id, this.constructForm(prevenirClub))
        .then(function (response) {
          self.$noty.success("Le bon de commande a bien été modifié")
          this.$emit('onNeedRefreshOrder', true)
          this.disabledBtn = false
        }, (response) => {
          self.$noty.error("Erreur dans la sauvegarde du bon de commande")
          this.disabledBtn = false
        });
    },
    isInputLoading: function (input) {
      return _.indexOf(this.loadingInputs, input) >= 0 ? true : false
    },
    addToLoadingInputs: function (input) {
      this.loadingInputs.push(input)
    },
    removeFromLoadingInputs: function (input) {
      this.loadingInputs = _.without(this.loadingInputs, input)
    },
    removeProduct: function (id) {
      let self = this
      this.isTableProduitsLoading(true);
      this.$http.post(this.getRoute('Secretariat.ordermyabft.removeProduct'), {
        "id": id,
      }).then(function (response) {
        self.$noty.success("Le produit a bien été supprimé de ce bon de commande")
        self.$emit('onNeedRefreshOrder')
        // self.getTableLicencesWithoutOrder()
        // self.getTableLicencesCurrentYear()
        self.disabledBtn = false
        this.isTableProduitsLoading(false);
      }, (response) => {
        self.$noty.error("Erreur dans la suppression du produit")
        self.disabledBtn = false
        this.isTableProduitsLoading(false);
      });
    },
  }
  ,
  filters: {
    idFormat: function (value) {
      return new Intl.NumberFormat("de-DE").format(value)
    }
  }
  ,
}
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/MyABFT/MainFormOrder.vue